module.exports = __webpack_public_path__ + "static/img/toux.f4903d8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toux.jpeg
// module id = hQSu
// module chunks = 1